import React from 'react';
import { Button, Flex, Typography } from './index';
import { TYPOGRAPHY, TYPOGRAPHY_COLOR } from '../../constants';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({
      error: error || new Error('Unknown error occurred'),
      errorInfo: errorInfo || { componentStack: 'No component stack available' }
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center px-4 py-8">
          <div className="max-w-md w-full bg-white rounded-2xl shadow-xl p-10 text-center flex flex-col gap-6">
            {/* Error Icon - Flat Design */}
            <div className="w-20 h-20 bg-gradient-to-br from-red-400 to-red-500 rounded-2xl flex items-center justify-center mx-auto shadow-lg">
              <svg className="w-10 h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.728-.833-2.498 0L4.316 16.5c-.77.833.192 2.5 1.732 2.5z" />
              </svg>
            </div>
            
            {/* Error Title */}
            <Typography
              type={TYPOGRAPHY.TITLE}
              text="Oops! Something went wrong"
              className="mb-8 text-gray-900 leading-loose"
            />
            
            {/* Error Description */}
            <Typography
              type={TYPOGRAPHY.PARA}
              className="text-gray-600 mb-14 leading-normal"
              text="We're sorry, but something unexpected happened. Our team has been notified and is working to fix this issue."
            />
            
            {/* Action Buttons - Consistent and Aligned */}
            <div className="flex flex-col sm:flex-row gap-3 justify-center items-center w-full">
              <Button
                text="Reload Page"
                buttonProps={{ 
                  type: 'primary',
                  className: "w-full sm:w-auto px-8 py-3 h-auto text-base font-medium"
                }}
                onClick={() => window.location.reload()}
              />
              <Button
                text="Go Back"
                buttonProps={{ 
                  type: 'default',
                  className: "w-full sm:w-auto px-8 py-3 h-auto text-base font-medium"
                }}
                onClick={() => window.history.back()}
              />
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
